module.exports = __webpack_public_path__ + "img/6f8e6db.png";